import { render, staticRenderFns } from "./lookDirectRuleDialog.vue?vue&type=template&id=72ecde75"
import script from "./lookDirectRuleDialog.vue?vue&type=script&lang=js"
export * from "./lookDirectRuleDialog.vue?vue&type=script&lang=js"
import style0 from "./lookDirectRuleDialog.vue?vue&type=style&index=0&id=72ecde75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports